<div class="modal-header">
  <h4 class="modal-title">{{"delete.check.modal.title" | translate}}</h4>
  <button
    (click)="activeModal.dismiss()"
    [ngbTooltip]="'modal.close' | translate"
    aria-label="Close"
    class="btn-close"
    type="button"></button>
</div>
<div class="modal-body">{{"delete.check.modal.body" | translate: {param: entity} }}</div>
<div class="modal-footer">
  <button (click)="activeModal.dismiss()" class="btn btn-outline-primary" type="button">{{ "functionbar.cancel" | translate }}</button>
  <button (click)="activeModal.close()" class="btn btn-primary" type="submit">{{ "functionbar.delete" | translate }}</button>
</div>
